module.exports = __webpack_public_path__ + "static/img/presysv70Three.30aff84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv70Three.png
// module id = vJSu
// module chunks = 1